/**
 * Répartit une liste en N colonnes en **suivant l'ordre de lecture** : le
 * premier élément à gauche, le deuxième au milieu, le troisième à droite, le
 * quatrième repart à gauche sur la ligne suivante.
 *
 * ⚠️ Corrigé le 2026-08-14. Le découpage précédent était contigu — chaque
 * colonne recevait une tranche de la liste — et donnait, pour 4 liens sur 3
 * colonnes, `[1] [2,3] [4]` : en lisant la première ligne on obtenait 1, 2, 4,
 * et le 3 tombait sous le 2. L'ordre affiché ne correspondait pas à l'ordre
 * saisi dès qu'il y avait plus de liens que de colonnes.
 *
 * Le nombre de colonnes est borné par le nombre d'éléments, pour qu'aucune
 * colonne ne soit vide.
 */
export function distributeIntoColumns(items, columns) {
  if (!items?.length) return [];
  const numCols = Math.max(1, Math.min(Math.max(1, Math.round(columns) || 1), items.length));
  const result = Array.from({ length: numCols }, () => []);
  items.forEach((item, index) => result[index % numCols].push(item));
  return result;
}

/**
 * La colonne où atterrirait le `index`-ième élément de la répartition.
 *
 * Sert à poser un élément qui n'est pas dans la liste — les liens de
 * consentement du pied de page — à la place qu'il occuperait si on l'y avait
 * mis, pour qu'il prolonge le flux au lieu de s'ajouter à côté.
 */
export function columnOfIndex(index, columnCount) {
  if (!columnCount || columnCount < 1) return 0;
  return index % columnCount;
}
